module.exports = __webpack_public_path__ + "img/profilo_jobmule.d5f2fb1f.png";